import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { EmojiEvent } from '@ctrl/ngx-emoji-mart/ngx-emoji';

@Component({
  selector: 'ngx-emoji',
  templateUrl: './emoji.component.html',
  styleUrls: ['./emoji.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class EmojiModalComponent {
  constructor(private dialogRef: MatDialogRef<EmojiModalComponent>) {}

  addEmoji(event: EmojiEvent) {
    this.dialogRef.close(event.emoji.native);
  }

  close(): void {
    this.dialogRef.close(false);
  }
}
